import { render, staticRenderFns } from "./agreements.vue?vue&type=template&id=46659018&scoped=true&"
import script from "./agreements.vue?vue&type=script&lang=js&"
export * from "./agreements.vue?vue&type=script&lang=js&"
import style0 from "./agreements.vue?vue&type=style&index=0&id=46659018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46659018",
  null
  
)

export default component.exports